import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import StaffTable from './StaffTable';
import { LoadingSpinner } from '@/_elements/Loaders';
import { IoMdArrowBack } from 'react-icons/io';

const BucketStaff = ({ bucket, staff, isLoading, onBack, providerId, onSave }) => {
    return (
        <div className="mt-4">
            <div className="d-flex justify-content-start align-items-center">
                <Button variant="secondary" onClick={onBack}>
                    <IoMdArrowBack />
                </Button>
                <span className="ml-4">
                    <strong>
                        <h3>{bucket.name} - Staff</h3>
                    </strong>
                </span>
            </div>
            <div className="d-flex justify-content-between mb-4 mt-4"></div>

            {isLoading ? (
                <LoadingSpinner />
            ) : staff.length === 0 ? (
                <Alert variant="info">No staff members in this bucket.</Alert>
            ) : (
                <StaffTable staff={staff} providerId={providerId} onSave={onSave} />
            )}
        </div>
    );
};

export default BucketStaff;
